import { itemTextLang } from '@/features/publicsite/contentLanguage';
import type { EventItem } from '@/features/publicsite/types/events/EventItem';
import type { EventTranslatedField } from '@/features/publicsite/types/events/EventTranslatedField';
import type { Language } from '@/i18n/types';

/**
 * The `lang` one of an event's texts needs on a page in `pageLanguage`. An event with an English
 * version can still carry a field nobody translated, which the server serves in Romanian and names
 * in `untranslatedFields`.
 */
export function eventTextLang(
  event: Pick<EventItem, 'contentLanguage' | 'untranslatedFields'>,
  field: EventTranslatedField,
  pageLanguage: Language,
): Language | undefined {
  return itemTextLang(event, field, pageLanguage);
}
